<template>
  <div class="card mb-25 border-0 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Ajouter un mouvement de fiche</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="mouvementForm" @submit="addMouvement" :validation-schema="mouvementSchema">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4 mb-2">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date Opération <span class="text-danger">*</span>
                  </label>
                  <input v-model="dateOperation" name="dateOperation" type="datetime-local" :max="currentDateTime"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Date oper." />
                  <!-- <ErrorMessage name="dateOperation" class="text-danger" /> -->
                </div>
              </div>
              <div class="col-md-8 mb-3">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold mb-10">
                    Bon <span class="text-danger">*</span>
                  </label>
                  <Field v-model="ficheProduit" name="bonLivre" type="text" v-slot="{ field }">
                    <Multiselect :options="bonOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" placeholder="Sélectionner le bon" @select="selectBon(field.value)" />
                  </Field>
                  <!-- <ErrorMessage name="bonLivre" class="text-danger" /> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 m-10">
            <div class="row">
              <div class="border border-primary mb-10">
                <div class="row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary">
                  <div class="col-md-7">
                    <h4 class="fs-4 text-white">Les mouvements</h4>
                  </div>
                  <div class="col-md-5">
                    <div class="d-flex float-end">
                      <button class="btn btn-success" type="button" :class="{ 'cursor-not-allowed': isDisable }"
                        @click="addRowMovement()">
                        <i class="fa fa-plus-circle position-relative me-1 fs-12"></i>Ajouter un produit
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="accordion dark-accordion my-3 py-7" id="magasin">
                    <div class="accordion-item accordion-wrapper" v-for="(produit, produitIndex) in produits"
                      :key="produitIndex">
                      <h2 class="accordion-header" :id="`magasin${produitIndex}`">
                        <button
                          :class="`accordion-button bg-light-primary font-primary ${produits.length == produitIndex + 1 ? '' : 'collapsed'}`"
                          type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse${produitIndex}`"
                          :aria-expanded="`${produits.length == produitIndex + 1 ? true : false}`"
                          :aria-controls="`collapse${produitIndex}`">
                          {{ produit.nomProd ? produit.nomProd : `Produit ${produitIndex + 1}` }}
                          <i class="vue-feather vue-feather--chevron-down svg-color" data-name="chevron-down"
                            data-tags="expand" data-type="chevron-down"><svg xmlns="http://www.w3.org/2000/svg"
                              width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                              class="feather feather-chevron-down vue-feather__content">
                              <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                          </i>
                        </button>
                      </h2>
                      <div :class="`accordion-collapse collapse ${produits.length == produitIndex + 1 ? 'show' : ''}`"
                        :id="`collapse${produitIndex}`" :aria-labelledby="`magasin${produitIndex}`"
                        data-bs-parent="#magasin">
                        <div class="accordion-body">
                          <div class="row gx-2">
                            <div class="col-md-5 mb-2">
                              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">Produit</label>
                                <Multiselect v-model="produit.produit" :options="produitOptions" :searchable="true"
                                  placeholder="Sélectionner un produit"
                                  @select="selectProd(produit.produit, produit, produitIndex)" />
                                <div class="text-danger" v-if="validateRowProduit(produit.produit)">Le produit est
                                  obligatoire.</div>
                                <div class="text-danger" v-if="validateDupliacatProduit(produit.produit)">Le produit a
                                  été déjà sélectionné.</div>
                              </div>
                            </div>
                            <!-- Cas typeBon == 0 : Quantité Bon et Reste à livrer -->
                            <div class="col-md-3 mb-2" v-if="parseInt(typeBon) === 0">
                              <div class="form-group">
                                <label class="d-block text-black fw-semibold">
                                  Quantité Bon <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input type="number" name="qteBon" readonly v-model="produit.qteBon"
                                    :class="validateRowProduit(produit.qteBon) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'"
                                    placeholder="Entrer la quantité" />
                                  <span class="input-group-text" id="inputGroup-sizing-default">{{ produit.uniteMesure
                                    }}</span>
                                </div>
                                <div class="text-danger" v-if="validateRowProduit(produit.qteBon)">La quantité bon est
                                  obligatoire.</div>
                              </div>
                            </div>
                            <div class="col-md-3 mb-2" v-if="parseInt(typeBon) === 0">
                              <div class="form-group">
                                <label class="d-block text-black fw-semibold">
                                  Reste à livrer <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input type="number" name="resteAliv" readonly v-model="produit.resteAliv"
                                    :class="validateRowProduit(produit.resteAliv) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'"
                                    placeholder="Entrer la quantité" />
                                  <span class="input-group-text" id="inputGroup-sizing-default">{{ produit.uniteMesure
                                    }}</span>
                                </div>
                                <div class="text-danger" v-if="validateRowProduit(produit.resteAliv)">Le reste à livrer
                                  est obligatoire.</div>
                              </div>
                            </div>
                            <!-- Cas typeBon == 1 : Quantité commandée et Quantité reste à recevoir -->
                            <div class="col-md-3 mb-2" v-if="parseInt(typeBon) === 1">
                              <div class="form-group">
                                <label class="d-block text-black fw-semibold">
                                  Quantité commandée <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input type="number" name="qteBon" readonly v-model="produit.qteBon"
                                    :class="validateRowProduit(produit.qteBon) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'"
                                    placeholder="Entrer la quantité" />
                                  <span class="input-group-text" id="inputGroup-sizing-default">{{ produit.uniteMesure
                                    }}</span>
                                </div>
                                <div class="text-danger" v-if="validateRowProduit(produit.qteBon)">La quantité commandée
                                  est obligatoire.</div>
                              </div>
                            </div>
                            <div class="col-md-3 mb-2" v-if="parseInt(typeBon) === 1">
                              <div class="form-group">
                                <label class="d-block text-black fw-semibold">
                                  Quantité reste à recevoir <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input type="number" name="resteAliv" readonly v-model="produit.resteAliv"
                                    :class="validateRowProduit(produit.resteAliv) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'"
                                    placeholder="Entrer la quantité" />
                                  <span class="input-group-text" id="inputGroup-sizing-default">{{ produit.uniteMesure
                                    }}</span>
                                </div>
                                <div class="text-danger" v-if="validateRowProduit(produit.resteAliv)">La quantité reste
                                  à recevoir est obligatoire.</div>
                              </div>
                            </div>
                            <!-- Cas typeBon == 2 : Quantité retournée et Reste à retourner -->
                            <div class="col-md-3 mb-2" v-if="parseInt(typeBon) === 2">
                              <div class="form-group">
                                <label class="d-block text-black fw-semibold">
                                  Quantité retournée <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input type="number" name="qteBon" readonly v-model="produit.qteBon"
                                    :class="validateRowProduit(produit.qteBon) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'"
                                    placeholder="Entrer la quantité" />
                                  <span class="input-group-text" id="inputGroup-sizing-default">{{ produit.uniteMesure
                                    }}</span>
                                </div>
                                <div class="text-danger" v-if="validateRowProduit(produit.qteBon)">La quantité retournée
                                  est obligatoire.</div>
                              </div>
                            </div>
                            <div class="col-md-3 mb-2" v-if="parseInt(typeBon) === 2">
                              <div class="form-group">
                                <label class="d-block text-black fw-semibold">
                                  Reste à retourner <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input type="number" name="resteAliv" readonly v-model="produit.resteAliv"
                                    :class="validateRowProduit(produit.resteAliv) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'"
                                    placeholder="Entrer la quantité" />
                                  <span class="input-group-text" id="inputGroup-sizing-default">{{ produit.uniteMesure
                                    }}</span>
                                </div>
                                <div class="text-danger" v-if="validateRowProduit(produit.resteAliv)">Le reste à
                                  retourner est obligatoire.</div>
                              </div>
                            </div>
                            <!-- Bouton de suppression -->
                            <div class="col-md-1 mt-4">
                              <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                                @click="removeRowMagasin(produitIndex)">
                                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                              </button>
                            </div>
                          </div>
                          <!-- Suite du template (magasins, etc.) reste inchangée -->
                          <div class="border border-primary mb-10">
                            <div
                              class="row gx-0 d-flex align-items-center justify-content-between fw-bold p-2 bg-primary">
                              <div class="col-md-7">
                                <h5 class="fs-6 mx-1 text-white">Les magasins</h5>
                              </div>
                              <div class="col-md-5">
                                <div class="d-flex float-end">
                                  <button class="btn btn-sm btn-success" type="button"
                                    @click="addRowProduit(produitIndex)">
                                    <i class="fa fa-plus-circle position-relative me-1 fs-12"></i>Ajouter un magasin
                                  </button>
                                </div>
                              </div>
                            </div>
                            <!-- Contenu des magasins reste identique -->


                            <div class="p-3">
                              <div class="row mt-10 gx-1">
                                <div class="col-md-3">
                                  <label class="d-block text-black fw-semibold">
                                    Magasin
                                    <span class="text-danger">*</span>
                                  </label>
                                </div>
                                <div class="col-md-3">
                                  <label class="d-block text-black fw-semibold">
                                    Fiche Produit
                                    <span class="text-danger">*</span>
                                  </label>
                                </div>
                                <div class="col-md-2">
                                  <label class="d-block text-black fw-semibold mb-10">
                                    Stock<span class="text-danger">*</span>
                                  </label>
                                </div>
                                <div class="col-md-3" v-if="parseInt(typeBon) === 1 || parseInt(typeBon) === 2">
                                  <label class="d-block text-black fw-semibold mb-10">
                                    Quantité à mettre en stock<span class="text-danger">*</span>
                                  </label>
                                </div>
                                <div class="col-md-3" v-if="parseInt(typeBon) === 0">
                                  <label class="d-block text-black fw-semibold mb-10">
                                    Quantité à retirer du stock<span class="text-danger">*</span>
                                  </label>
                                </div>
                                <!-- <div class="col-md-2">
                                  <label class="d-block text-black fw-semibold mb-10">
                                    stock Actuel
                                  </label>
                                </div> -->
                                <div class="col-md-1">
                                  <label class="d-block text-black fw-semibold mb-10">
                                    Action
                                  </label>
                                </div>
                                <hr class="mt-0" />
                              </div>
                              <div class="row gx-2 gy-0" v-for="(mov, movIndex) in produit.mouvements" :key="movIndex">
                                <div class="col-md-3">
                                  <div class="form-group mb-2">
                                    <Multiselect :options="magasinOptions" :searchable="true" track-by="label"
                                      label="label" v-model="mov.magasin"
                                      @select="selectMov(mov.magasin, mov, produitIndex, movIndex)"
                                      placeholder="Sélectionner le magasin" />
                                    <div class="text-danger" v-if="validateRowProduit(mov.magasin)">
                                      Le magasin est obligatoire.
                                    </div>
                                    <div class="text-danger" v-if="validateDupliacatMag(mov.magasin, produitIndex)">
                                      Le magasin a été déja selectionné.
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-2">
                                  <div class="form-group mb-2 ">
                                    <input type="text" readonly v-model="mov.fiche.numFiche" :class="validateRowProduit(mov.fiche.numFiche)
                                      ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                      : 'form-control shadow-none fs-md-15 text-black '" placeholder="" />
                                    <div v-if="validateRowProduit(mov.fiche.numFiche)" class="invalid-feedback">
                                      La fiche est obligatoire.
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-3">
                                  <div class="input-group">
                                    <input type="number" readonly v-model="mov.fiche.stock"
                                      class="form-control shadow-none fs-md-15 text-black" />
                                    <span class="input-group-text" id="inputGroup-sizing-default">{{
                                      mov.fiche.libelleCod }}</span>
                                  </div>
                                </div>

                                <div class="col-md-3">
                                  <div class="form-group mb-2 ">
                                    <!-- <input type="number" v-model="mov.qte" :class="validateRowProduit(mov.qte)
                                      ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                      : 'form-control shadow-none fs-md-15 text-black '"
                                      placeholder="Entrer la quantité" /> -->
                                    <div class="input-group">
                                      <input type="number" v-model="mov.qte" :class="validateRowProduit(mov.qte)
                                        ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                        : 'form-control shadow-none fs-md-15 text-black '"
                                        placeholder="Entrer la quantité" aria-label="Sizing example input"
                                        aria-describedby="inputGroup-sizing-sm" />
                                      <span class="input-group-text" id="inputGroup-sizing-default">{{
                                        produit.uniteMesure }}</span>
                                    </div>
                                    <div v-if="validateRowProduit(mov.qte)" class="invalid-feedback">
                                      La quantité est obligatoire.
                                    </div>
                                    <div v-if="produit.qteEstSup" class="text-danger">
                                      Vous avez depassé la quantité restante.
                                    </div>
                                  </div>
                                </div>
                                <!-- <div class="col-md-2">
                                  <div class="form-group mb-2">
                                    <input v-model="mov.stockActuel" type="number" readonly
                                      class="form-control shadow-none fs-md-15 text-black" placeholder="" />
                                  </div>
                                </div> -->
                                <div class="col-md-1 mb-2">
                                  <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                                    @click="removeRowProduit(produitIndex, movIndex)">
                                    <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center ">
              <button v-if="produits.length > 0" class="btn btn-success me-3" type="submit" :disabled="isDisable">
                Ajouter un mouvement
              </button>
              <router-link to="/inventaires/liste-mouvements" class="btn btn-danger"><i
                  class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { Form, Field } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, format_date, success, getCurrentDateTime } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect/src/Multiselect';
import { el } from '@fullcalendar/core/internal-common';

export default defineComponent({
  name: "AddMouvementFiche",
  components: {
    Form,
    Field,
    Multiselect
  },

  setup: () => {
    const mouvementSchema = Yup.object().shape({
      // bonLivre: Yup.string().required("Le bon est obligatoire."),
      // dateOperation: Yup.string().required("La date d'opération est obligatoire."),
    })

    const typeOperation = ref("");
    const produits = reactive([]);
    watch(produits, (newValue) => {
      newValue.forEach((produit) => {
        let totalMov = 0;
        if (produit.mouvements?.length) {
          produit.mouvements.forEach((mouvement, ind) => {
            totalMov += mouvement.qte;

            let newStockActuel =
            ind > 0 ? mouvement.fiche.stock : (
              typeOperation.value === "Entrée"
                ? mouvement.qte + mouvement.fiche.stock
                : mouvement.fiche.stock - mouvement.qte
            );

            if (mouvement.stockActuel !== newStockActuel) {
              mouvement.stockActuel = newStockActuel;
            }
          });
        }

        if (produit.resteAliv < totalMov) {
          produit.qteEstSup = true;
        }else{
          produit.qteEstSup = false;
        }
      });

      isDisable.value = newValue.some((produit) =>
        produit.qteBon < 1 ||
        produit.uniteMesure === '' ||
        produit.produit === '' ||
        produit.resteAliv < 0 ||
        produit.qteEstSup ==true ||
        produit.mouvements.some((mouvement) => mouvement.qte < 1 || mouvement.magasin === '' || mouvement.fiche.id === 0)
      );
    }, { deep: true });


    const addRowMovement = () => {
      produits.push({
        produit: '',
        qteBon: 0,
        resteAliv: 0,
        qteEstSup:false,
        uniteMesure: '',
        nomProd: "",
        mouvements: [
          {
            magasin: '',
            stockActuel: 0,
            qte: 0,
            fiche: {
              id: 0,
              stock: 0,
              numFiche: "",
              libelleCod: ""
            },
          }
        ],
      },);
    };

    const addRowProduit = (magasinIndex) => {
      produits[magasinIndex].mouvements.push({
        magasin: '',
        stockActuel: 0,
        qte: 0,
        fiche: {
          id: 0,
          stock: 0,
          numFiche: "",
          libelleCod: ""
        },
      });
    };

    const removeRowMagasin = (index) => {
      produits.splice(index, 1);
    };

    const removeRowProduit = (magasinIndex, produitIndex) => {
      produits[magasinIndex].mouvements.splice(produitIndex, 1);
    };

    const selectMov = (selectedMagasin, mov, index, indexMag) => {
      mov.nomMagasin = selectedMagasin.split("|")[1]
      mov.qte = 0;
      mov.stockActuel = 0;
      mov.fiche = {
        id: 0,
        stock: 0,
        numFiche: "",
        libelleCod: ""
      };
      fetchFiche(selectedMagasin.split("|")[0], produits[index].produit.split("|")[4],produits[index].produit.split("|")[9], index, indexMag);
    };


    const selectProd = (selectedProduit, produit, index) => {
      console.log(selectedProduit, "selectedProduitselectedProduitselectedProduit", selectedProduit.split("|")[2])
      produit.nomProd = selectedProduit.split("|")[6] + "|" + selectedProduit.split("|")[7] + "|" + selectedProduit.split("|")[8];
      produit.uniteMesure = selectedProduit.split("|")[3];
      produit.qteBon = selectedProduit.split("|")[1];
      produit.resteAliv = selectedProduit.split("|")[2];
      produits[index].mouvements.length = 0;
      addRowProduit(index);

      console.log(produit, "produitproduitproduit")
    };

  const fetchBons = async () => {
  try {
    const response = await ApiService.get("/bonlivraisons");
    const invData = response.data.data;
    console.log("invData:===>", invData);
    bonOptions.value = invData.map((inv) => {
      // Détermine le nom à afficher (client ou fournisseur)
      let entityName = "";
      if (inv?.client) {
        entityName = inv.client.nomClient && inv.client.prenomClient
          ? `${inv.client.nomClient} ${inv.client.prenomClient}`
          : inv.client.raisonSociale || "";
      } else if (inv?.fournisseur) {
        entityName = inv.fournisseur.nomFournisseur && inv.fournisseur.prenomFournisseur
          ? `${inv.fournisseur.nomFournisseur} ${inv.fournisseur.prenomFournisseur}`
          : inv.fournisseur.raisonSociale || "";
      }

      return {
        value: `${inv.id}|${inv.typeOperation}|${inv.typeBon}`,
        label: `[${format_date(inv.dateOperation)}] ${inv.refDoc}-${entityName} | ${inv.typeOperation}`
      };
    });
    console.log(bonOptions, "inventaireOptionsinventaireOptions");
  } catch (error) {
    console.log("Erreur lors de la récupération des bons:", error);
  }
};
    // const fetchBons = async () => {
    //   try {
    //     const response = await ApiService.get("/bonlivraisons");
    //     const invData = response.data.data;
    //     console.log("invData:===>", invData);
    //     bonOptions.value = invData.map((inv) => ({
    //       value: `${inv.id}|${inv.typeOperation}|${inv.typeBon}`,
    //       //label: `[${format_date(inv.dateOperation)}]${inv.refDoc}-${inv.typeOperation}-${inv.typeBon}`,
    //       label: `[${format_date(inv.dateOperation)}] ${inv.refDoc}-${((inv?.client?.nomClient + ' ' + inv?.client?.prenomClient) || inv?.client?.raisonSociale || "")} | ${inv.typeOperation}`

    //     }));
    //     console.log(bonOptions, "inventaireOptionsinventaireOptions")
    //   } catch (error) {
    //     //
    //   }
    // };

    const fetchMagasins = async () => {
      try {
        const response = await ApiService.get("/all/all/magasins");
        const magasinsData = response.data.data;
        magasinOptions.value = magasinsData.map((magasin) => ({
          value: magasin.id + "|" + magasin.nomMagasin,
          label: magasin.code + ' - ' + magasin.nomMagasin + ' du ' + magasin.magasin.nomMagasin,
        }));
      } catch (error) {
        //
      }
    };

    async function getBonById(id) {
      await ApiService.get(`/bonlivraisons/` + id)
        .then(({ data }) => {
          magasinss.value = data.data;
          console.log(data, data.data.produitcondibons, "data.data.inventaiprocondimags");
          typeOperation.value = data.data["typeOperation"]
          data.data.produitcondibons.forEach(produit => {
            produitOptions.value.push({
              value: produit.id + "|" + produit.qteBon + "|" + produit.resteAliv + "|" + produit.uniteMesure + "|" + produit.produit.produit.id + "|" + produit.nomProd  + "|" + produit.produit.id,
              label: produit.nomProd.split("|")[1] + " | " + produit.nomProd.split("|")[2] + " | " + produit.nomProd.split("|")[3],
            })
          });
          console.log(produitOptions, "produitOptionsproduitOptions");
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    const selectBon = async (selectedMagasin) => {
      if (selectedMagasin) {
        typeBon.value = selectedMagasin.split("|")[2];
        produitOptions.value.length = 0;
        await getBonById(selectedMagasin);
        produits.length = 0;
        
        addRowMovement();
      }
    };

    const isDis = ref(true);
    const typeBon = ref("");
    const bonOptions = ref([]);
    const inventaire = ref("");
    const mouvementForm = ref(null);
    const router = useRouter();

    const magasinOptions = ref([]);
    const produitOptions = ref([]);
    const clientOptions = ref([]);
    const motifSuiviOptions = ref([]);
    const isDisable = ref(true);
    const magasinss = ref("");
    const ficheProduit = ref("");
    const dateOperation = ref(getCurrentDateTime());
    const currentDateTime = ref(getCurrentDateTime());

    const mouvements = reactive([
      {
        typeOperation: '',
        qte: 0,
        motifsSuivi: 0,
        client: 0,
        refDoc: '',
        stockActuel: 0,
        dateOperation: "",
        ficheProduit: ficheProduit.value.split("|")[0]
      }
    ]);

    const magasin = ref();


    const removeRowMouvement = (produitIndex) => {
      mouvements.splice(produitIndex, 1);
    };



    const valideteRowMouvement = (e) => {
      if (e === null || e === undefined || e === "" || e === 0) {
        return true; // Champs invalides
      } else {
        return false; // Champs valides
      }
    };



    const addMouvement = async (values, { resetForm }) => {
      console.log(values, "mouvementForm.value")
      if (!mouvementForm.value) return;
      // const isValid = await mouvementForm.value.validate();
      const mouvementes = [];
      produits.forEach((produit) => {
        produit.mouvements.forEach((mouvement) => {
          mouvementes.push({
            produitCondiBon: produit.produit.split("|")[0],
            magasin: mouvement.magasin.split("|")[0],
            typeOperation: typeOperation.value,
            qte: mouvement.qte,
            stockActuel: mouvement.stockActuel,
            dateOperation: dateOperation.value,
            ficheProduit: mouvement.fiche.id,
            prcond: produit.produit.split("|")[9],
            prt: produit.produit.split("|")[4],
          });
        });
      });

      console.log(mouvementes, "ffffffffffffff")
      try {
        await ApiService.post('/mouvementfiches', mouvementes);
        success("Mouvement ajouté avec succès");
        router.push({ name: "ListeMouvementFiche" });
      } catch (err) {
        error("Erreur lors de l'ajout du mouvement");
      }
    };

    const produit = ref();
    const fetchFiche = async (mag, prod,prodCond, index: number, indexp: number) => {
      await ApiService.get("/ficheproduit/produit/magasin/" + mag + "/" + prod + "/" + prodCond)
        .then(({ data }) => {
          const donnees = data.data;
          produits[index].mouvements[indexp].fiche.id = data.data["id"];
          produits[index].mouvements[indexp].fiche.libelleCod = data.data["libelleCod"];
          produits[index].mouvements[indexp].fiche.stock = data.data["stock"];
          produits[index].mouvements[indexp].fiche.numFiche = data.data["numFiche"];
        })
        .catch(({ response }) => {
          // error(response.data.message)
        });
    }

    const validateDupliacatMag = (e, index) => {
      console.log(e, "zzzzzzzzzzzzzzzzzzzz", index)
      if (e == null || e == "") {
        return false;
      }
      console.log(produits[index].mouvements, "produits[index].mouvement")
      return produits[index].mouvements.filter((element) => element.magasin === e).length > 1;
    };

    const validateDupliacatProduit = (e) => {
      console.log(e, "uuuuuuuuuuuuuu")
      if (e == null || e == "") {
        return false;
      }
      return produits.filter((element) => element.produit === e).length > 1;
    };


    onMounted(async () => {
      fetchMagasins();
      fetchBons();
      currentDateTime.value = getCurrentDateTime();
    });

    const validateRowProduit = (e) => {
      return e === '' || e === 0 || e === '0' || e == null || e < 0;
    };

    return {
      selectMov,
      selectBon,
      mouvements,
      typeOperation,
      //addRowMouvement,
      removeRowMouvement,
      clientOptions,
      currentDateTime,
      magasin,
      //selectMag,
      selectProd,
      addMouvement,
      inventaire, isDis,
      mouvementForm,
      magasinOptions,
      motifSuiviOptions,
      produitOptions,
      ficheProduit,
      magasinss,
      typeBon,
      valideteRowMouvement,
      validateDupliacatMag,
      validateDupliacatProduit,
      isDisable,
      mouvementSchema,
      produits,
      produit,
      removeRowMagasin,
      removeRowProduit,
      addRowMovement,
      addRowProduit,
      validateRowProduit,
      dateOperation,
      getCurrentDateTime,
      bonOptions
    };
  },
});
</script>


<style scoped></style>
